import React, { useCallback } from 'react';

import { Input } from 'reactstrap';

const UpwardReduxIntegerInput = ({ input: { onChange, onBlur, value, ...restInput }, meta: { touched, error, warning }, className, ...custom }) => {
   const validateInput = useCallback((val) => {
      const intValue = parseInt(val, 10);
      return Number.isNaN(intValue) || !Number.isNaN(intValue);
   }, []);

   const handleInputChange = useCallback((event) => {
      const val = `${ event?.target?.value }`.replace(/[^\d]/g, '');
      const isValid = validateInput(val);

      if (isValid) {
         onChange(val);
      } else {
         console.log('Invalid Input');
      }
   }, []);

   return (
      <Input
         {...(touched ? { valid: !error } : {})}
         {...restInput}
         onChange={handleInputChange}
         onBlur={handleInputChange}
         {...custom}
         className={(touched && error ? ' is-invalid ' : '') + (className ? ` ${ className }` : '')}
         value={value}
      />
   );
};

export default UpwardReduxIntegerInput;
